import { AppBar, Toolbar, Box, Button, Container } from '@mui/material'
import { Link } from '@inertiajs/react'
import logo from '../assets/rounded_logo.svg'
import SecondaryButton from './SecondaryButton'

interface UtilPageNavigationProps {
  loginUrl?: string
}

export default function UtilPageNavigation({ loginUrl = '/renters/login' }: UtilPageNavigationProps) {
  const isActive = (path: string) => {
    return window.location.pathname === path
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: 'white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        zIndex: 1100
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 0 } }}>
          {/* Logo */}
          <Link href="/" style={{ textDecoration: 'none' }}>
            <Box
              component="img"
              src={logo}
              alt="HeyProperty"
              sx={{
                height: { xs: 32, sm: 40 },
                width: 'auto',
                cursor: 'pointer'
              }}
            />
          </Link>

          <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5, alignItems: 'center' }}>
            <Link href="/renters" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: isActive('/renters') ? 'grey.900' : 'grey.600',
                  textTransform: 'none',
                  fontWeight: isActive('/renters') ? 600 : 400,
                  fontSize: '0.875rem',
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'grey.900'
                  }
                }}
              >
                Renters
              </Button>
            </Link>
            <Link href="/landlord" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: isActive('/landlord') ? 'grey.900' : 'grey.600',
                  textTransform: 'none',
                  fontWeight: isActive('/landlord') ? 600 : 400,
                  fontSize: '0.875rem',
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'grey.900'
                  }
                }}
              >
                Landlords
              </Button>
            </Link>
            <Link href={loginUrl} style={{ textDecoration: 'none' }}>
              <SecondaryButton sx={{ px: 3, fontSize: '0.875rem', fontWeight: 600 }}>
                Login
              </SecondaryButton>
            </Link>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
